import { gql } from '@apollo/client';
import { FIRST_MILE_IMPORT_FRAGMENT } from 'graphql/secure/fragments/import.fragments';

export const GET_FIRST_MILE_IMPORTS = gql`
  query GetFirstMileImports($companyId: UUID) {
    firstMileImports(ownedById: $companyId) {
      edges {
        node {
          ...firstMileImportValues
        }
      }
    }
  }
  ${FIRST_MILE_IMPORT_FRAGMENT}
`;

export const GET_FIRST_MILE_IMPORT = gql`
  query GetFirstMileImport($id: UUID!) {
    firstMileImport(id: $id) {
      ...firstMileImportValues
      rows {
        edges {
          node {
            siteTitle
            farmExternalId
            rawMaterialIds
            locationCoordinates {
              lat
              lng
            }
            farmSize
            farmDescription
          }
        }
      }
    }
  }
  ${FIRST_MILE_IMPORT_FRAGMENT}
`;
